/* eslint-disable @typescript-eslint/no-explicit-any */
import { createCustomEqual } from 'fast-equals';
import React, { useEffect, useRef, useState } from 'react';

const deepCompareEqualsForMaps = createCustomEqual(
  (deepEqual: any) => (a: any, b: any) =>
    new window.google.maps.LatLng(a).equals(new window.google.maps.LatLng(b)),
);
// if (
//   isLatLngLiteral(a) ||
//   a instanceof window.google.maps.LatLng ||
//   isLatLngLiteral(b) ||
//   b instanceof window.google.maps.LatLng
// )
// TODO extend to other types
// use fast-equals for other objects
// return deepEqual(a, b);

function useDeepCompareMemoize(value: any) {
  const ref = useRef();

  if (!deepCompareEqualsForMaps(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}

function useDeepCompareEffectForMaps(callback: any, dependencies: any) {
  useEffect(callback, [...dependencies.map(useDeepCompareMemoize), callback]);
}

export default function Map({
  onClick,
  onIdle,
  onBoundsChanged,
  onDragEnd,
  children,
  style,
  ...options
}: any) {
  const ref = useRef(null);
  const [map, setMap] = useState<any>();

  useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, {}));
    }
  }, [ref, map]);

  // because React does not do deep comparisons, a custom hook is used
  // see discussion in https://github.com/googlemaps/js-samples/issues/946
  useDeepCompareEffectForMaps(() => {
    if (map) {
      map.setOptions(options);
    }
  }, [map, options]);

  useEffect(() => {
    if (map) {
      ['click', 'idle', 'bounds_changed', 'dragend'].forEach((eventName) =>
        window.google.maps.event.clearListeners(map, eventName),
      );
      if (onClick) {
        map.addListener('click', onClick);
      }

      if (onIdle) {
        map.addListener('idle', () => onIdle(map));
      }

      if (onBoundsChanged) {
        map.addListener('bounds_changed', () => onBoundsChanged(map));
      }

      if (onDragEnd) {
        map.addListener('dragend', () => onDragEnd(map));
      }
    }
  }, [map, onClick, onIdle]);

  return (
    <>
      <div ref={ref} style={style} />

      {React.Children.map(children, (child) =>
        // set the map prop on the child component
        React.cloneElement(child, { map }),
      )}
    </>
  );
}
